import React from "react";
import { Card, Row, Col, Form, Button, Placeholder } from "react-bootstrap";
import { HiUserGroup } from "react-icons/hi";
import { MdOutlineViewHeadline } from "react-icons/md";
import { BrandTeam } from "../../../types/model";

interface SelectBrandTeamCardProps {
	selectedBrandTeam: BrandTeam;
	brandTeams: BrandTeam[];
	brandTeamLoading: boolean;
	handleSelectBrandTeam: (team: BrandTeam) => void;
	setShowRidersOnTeam: (show: boolean) => void;
}

const SelectBrandTeamCard: React.FC<SelectBrandTeamCardProps> = ({
	selectedBrandTeam,
	brandTeams,
	brandTeamLoading,
	handleSelectBrandTeam,
	setShowRidersOnTeam,
}) => {
	const handleBrandTeamChange = (
		event: React.ChangeEvent<HTMLSelectElement>,
	) => {
		const teamId = event.target.value;
		const selectedTeam = brandTeams.find((team) => team._id === teamId);
		if (selectedTeam) {
			handleSelectBrandTeam(selectedTeam);
		}
	};

	return (
		<Card className="mb-1 mt-3 py-0 bg-dark text-white border-0">
			<Card.Header className="bg-dark text-light">
				<HiUserGroup className="me-2 mb-1" />
				Select a Team
			</Card.Header>
			<Card.Body className="my-0">
				{brandTeamLoading ? (
					<Placeholder as="div" animation="glow" className="my-5">
						<Placeholder xs={8} bg="light" className="rounded-3 mb-2" />
						<Placeholder
							xs={11}
							className="rounded-3"
							bg="light"
							style={{ height: "13rem" }}
						/>
					</Placeholder>
				) : (
					<Row className="align-items-center py-0 my-0 text-center fw-bold justify-content-center">
						<Col md={3} className="text-center my-2 my-sm-0" />
						<Col md={6} className="text-center my-2 my-sm-0">
							<Form.Select
								size="sm"
								value={selectedBrandTeam._id}
								onChange={handleBrandTeamChange}
								className="border-primary bg-dark text-light fw-bold text-center fs-5"
								style={{ cursor: "pointer" }}
							>
								<option value="">Select a Team</option>
								{brandTeams.map((team: BrandTeam) => (
									<option key={team._id} value={team._id}>
										{team.name}
									</option>
								))}
							</Form.Select>
						</Col>
						<Col md={3} className="text-center my-2 my-sm-0">
							<Button
								variant="success"
								size="sm"
								className="border-0 text-light w-100"
								onClick={() => setShowRidersOnTeam(true)}
							>
								<MdOutlineViewHeadline className="mb-1 me-2" />
								View Riders
							</Button>
						</Col>
					</Row>
				)}
			</Card.Body>
		</Card>
	);
};

export default SelectBrandTeamCard;
